import { ContractInfo } from 'api/types/httpsTypes/contracts';

import { ComponentProps, JSXElementConstructor } from 'react';
import { CallsResultItem } from '../../research/components/TelegramCalls/CallsModal';
import { useQuery } from '@tanstack/react-query';
import {
  TelegramChannelsKeys,
  TelegramChannelsService,
} from 'api/services/httpServices/TelegramChannelsService';
import { TelegramCallDetailsInfo } from 'api/types/httpsTypes/telegram-channels';

interface Props {
  contract: ContractInfo;
}

export type SubCardProps<
  T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>
> = {
  as?: T;
} & ComponentProps<T>;

export const CallsInfo = ({ contract }: Props) => {
  const { data } = useQuery({
    queryFn: () =>
      TelegramChannelsService.getContractDetailedChannels({
        contractAddress: contract.generalInfo.address,
        chain: contract.generalInfo.chain.key,
        limit: 100,
        offset: 0,
      }),
    queryKey: TelegramChannelsKeys.getContractDetailedChannels(
      contract.generalInfo.chain.key,
      contract.generalInfo.address
    ),
  });

  const numberOfCalls = data?.pagination?.total;
  const calls = data?.data as TelegramCallDetailsInfo[];

  return numberOfCalls && calls ? (
    <ul className="flex flex-col xxs:gap-1 xxs:p-2 m-0 ">
      <>
        {calls.map((call) => (
          <CallsResultItem size="sm" key={call.callDatetime} option={call} />
        ))}
      </>
    </ul>
  ) : (
    <div className="justify-center item-center flex xxs:py-2">
      No calls found
    </div>
  );
};
